import { render, staticRenderFns } from "./DialogAddGroupTeacher.vue?vue&type=template&id=46e239b1&scoped=true"
import script from "./DialogAddGroupTeacher.vue?vue&type=script&lang=js"
export * from "./DialogAddGroupTeacher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e239b1",
  null
  
)

export default component.exports